import types from '../Types'

const initialvalues = {
  isRequested: false,
  error: '',
  reportHtml: '',
};

const reports = (state = initialvalues, action) => {
  switch (action.type) {
    case types.REPORTS_REQUEST:
      return {
        ...state,
        isRequested: true,
        error: '',
      };
    case types.REPORTS_HTML_REQUEST_SUCCESS:
      return {
        ...state,
        isRequested: false,
        reportHtml: action.reportHtml,
      };
    case types.REPORTS_REQUEST_ERROR:
      return {
        ...state,
        isRequested: false,
        error: action.error,
      };
    default:
      return state;
  }
}

export default reports;
